import{ useReducer, useMemo } from 'react';

const getInitialParams = (): Params => {
  return {
    page: 1,
    limit: 10,
    sortOrder: 'asc',
    sortBy: 'createdAt',
    search: undefined,
    stockAvailability: 'All',
    addedBy: undefined,
    storeId: undefined,
  };
};

type Params = {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  stockAvailability:string;
  addedBy:string | undefined;
  storeId?: string;
};

type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_STORE_ID'; payload: string | undefined }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload, page: 1 };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload, page: 1 };
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        page: 1,
      };
    case 'SET_STORE_ID':
      return { ...state, storeId: action.payload, page: 1 };
    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}

export function useItemManagementParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.stockAvailability,
    params.addedBy,
    params.storeId,
  ]);

  return { params: stableParams, dispatch };
}
